'use strict';
const { createAddQueries } = require('../addQueries');
const {
  createFilterConfig,
} = require('./commons');

module.exports = createAddQueries({
  baseUrl: () => '/rtns',
  returnModel: {
    name: 'rtn',
  },
  finders: [
    createFilterConfig('name', 'name', 'string'),
  ],
  orderBy: [
    createFilterConfig('name', 'name', 'string'),
  ],
});
